// custom form fields that allow more than one value (multiple checkboxes) return all the selected options as an object
// BE wants them sent as strings so we're manipulating those objects to strings with a ';' separator (same thing in line 19)
// we also don't want to send white space strings
export function sanitizeFormFieldValue(value) {
  return typeof value === 'object' ? value.join(';') : typeof value === 'string' ? value.trim() : value;
}